const headers = {
  name: "Product brand",
  navigate: {
    tabs: [
      {
        name: "Brands",
        path: "/app/products/brands",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
